import React, { Component } from "react";
import { connect } from "react-redux";

//Components
import { withStyles } from "@material-ui/core/styles";

function mapStateToProps(state) {
  return {
    state
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Styles
const styles = theme => ({
  root: {}
});

class Schedule extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;

    return <div className={classes.root}>Schedule</div>;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Schedule));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/dashboard_tabs/Schedule.js